var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8PhpLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd5f2",
    d: "M8,11.5c-4.065,0-7.5-1.832-7.5-4s3.435-4,7.5-4s7.5,1.832,7.5,4S12.065,11.5,8,11.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M8,4c4.125,0,7,1.845,7,3.5S12.125,11,8,11S1,9.155,1,7.5S3.875,4,8,4 M8,3C3.582,3,0,5.015,0,7.5 S3.582,12,8,12s8-2.015,8-4.5S12.418,3,8,3L8,3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#36404d",
    d: "M4.525 7C4.758 7 4.924 7.076 4.98 7.147 4.99 7.16 5.017 7.194 4.989 7.312 4.901 7.681 4.826 8 3.729 8H3.634l.188-1H4.525M4.525 6H2.992l-.75 4H3.22l.188-1h.321c1.256 0 1.978-.381 2.233-1.457C6.182 6.619 5.452 6 4.525 6L4.525 6zM12.525 7c.233 0 .399.076.455.147.01.013.037.047.009.165C12.901 7.681 12.826 8 11.729 8h-.094l.188-1H12.525M12.525 6h-1.534l-.75 4h.978l.188-1h.321c1.256 0 1.978-.381 2.233-1.457C14.182 6.619 13.452 6 12.525 6L12.525 6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#36404d",
    d: "M9.689,6.242C9.5,6.07,9.168,6,8.673,6H8.044l0.258-1H7.295L6.459,9h1.019l0.39-2h0.176h0.629 C8.742,7,8.801,7.002,8.85,7.004L8.468,9h1.04l0.348-1.926C9.93,6.692,9.874,6.412,9.689,6.242z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PhpLogo);
export default __webpack_public_path__ + "static/media/icons8-php-logo.34ba1821ec86b383b2816cab4d061034.svg";
export { ForwardRef as ReactComponent };